export const shintaiShougaisyaGradeOptions = [
  { title: 'なし', value: '' },
  { title: '1級', value: '1' },
  { title: '2級', value: '2' },
  { title: '3級', value: '3' },
  { title: '4級', value: '4' },
  { title: '5級', value: '5' },
  { title: '6級', value: '6' },
  { title: '7級', value: '7' },
];
